(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["al-home-experience"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseHome = (root) => {
      const home = root.matches?.('[data-al-home]') ? root : root.querySelector?.('[data-al-home]');
      if (!home || home.dataset.initialised === 'true') return;

      const video = home.querySelector('video');
      const scenes = Array.from(home.querySelectorAll('[data-al-home-scene]'));
      const mobileMotion = window.matchMedia('(max-width: 900px) and (prefers-reduced-motion: no-preference)').matches;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const activateVideo = () => {
        if (!video) return;
        video.muted = true;
        video.play().catch(() => {});
      };

      if ('IntersectionObserver' in window) {
        const sceneObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-active', 'is-revealed');
            });
          },
          { threshold: mobileMotion ? 0.14 : 0.35 }
        );
        scenes.forEach((scene) => sceneObserver.observe(scene));
      } else {
        scenes.forEach((scene) => scene.classList.add('is-active', 'is-revealed'));
      }

      if ('IntersectionObserver' in window && !reducedMotion) {
        const editorialItems = Array.from(home.querySelectorAll('.al-home-editorial__collection h2, .al-home-editorial__collections > div, .al-home-editorial__copy, .al-home-expressions img'));
        const editorialObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-inview');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.1 });
        editorialItems.forEach((item) => {
          item.classList.add('al-home-reveal');
          editorialObserver.observe(item);
        });
      }

      if (mobileMotion) {
        const groups = Array.from(
          home.querySelectorAll(
            '.al-home-hero__copy, .al-home-introduction__copy, .al-home-signatures__intro, .al-home-scene__copy, .al-home-philosophy__copy'
          )
        );
        home.classList.add('al-motion-ready');
        groups.forEach((group) => {
          group.classList.add('al-motion-group');
          Array.from(group.children).forEach((child, index) => {
            child.classList.add('al-motion-target');
            child.style.setProperty('--al-motion-order', String(index));
          });
        });

        const revealObserver = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-revealed');
              entry.target.closest('.al-home-introduction, .al-home-scene, .al-home-philosophy')?.classList.add('is-revealed');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -7% 0px', threshold: 0.12 }
        );
        groups.slice(1).forEach((group) => revealObserver.observe(group));
        window.requestAnimationFrame(() => groups[0]?.classList.add('is-revealed'));
      }

      document.addEventListener('pointerdown', activateVideo, { once: true });
      activateVideo();
      home.dataset.initialised = 'true';
    };

    const initialiseAll = (root = document) => {
      root.querySelectorAll?.('[data-al-home]').forEach((home) => initialiseHome(home));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll());
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["al-what-is"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseWhat = (root) => {
      const page = root.matches?.('[data-al-what]') ? root : root.querySelector?.('[data-al-what]');
      if (!page || page.dataset.initialised === 'true') return;

      const timeline = page.querySelector('[data-al-what-timeline]');
      const progress = page.querySelector('[data-al-what-progress]');
      const count = page.querySelector('[data-al-what-progress-count]');
      const chapters = Array.from(page.querySelectorAll('[data-al-what-chapter]'));
      const buttons = Array.from(page.querySelectorAll('[data-al-what-progress-button]'));
      const mobileMotion = window.matchMedia('(max-width: 900px) and (prefers-reduced-motion: no-preference)').matches;
      const total = String(chapters.length).padStart(2, '0');

      const setActive = (index) => {
        chapters.forEach((chapter, chapterIndex) => chapter.classList.toggle('is-active', chapterIndex === index));
        buttons.forEach((button, buttonIndex) => {
          const active = buttonIndex === index;
          button.classList.toggle('is-active', active);
          if (active) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });
        if (count) count.textContent = `${String(index + 1).padStart(2, '0')} / ${total}`;
      };

      const update = () => {
        const timelineRect = timeline?.getBoundingClientRect();
        progress?.classList.toggle(
          'is-visible',
          Boolean(timelineRect && timelineRect.top < window.innerHeight * 0.65 && timelineRect.bottom > window.innerHeight * 0.35)
        );

        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;
        chapters.forEach((chapter, index) => {
          const rect = chapter.getBoundingClientRect();
          const distance = Math.abs(rect.top + rect.height * 0.5 - window.innerHeight * 0.5);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        setActive(closestIndex);
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          document.getElementById(button.dataset.target)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      let updatePending = false;
      const requestUpdate = () => {
        if (updatePending) return;
        updatePending = true;
        window.requestAnimationFrame(() => {
          update();
          updatePending = false;
        });
      };

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);

      if (mobileMotion) {
        const groups = Array.from(
          page.querySelectorAll(
            '.al-what-opening__copy, .al-what-copy, .al-what-statement, .al-what-principles__intro, .al-what-principles article, .al-what-closing'
          )
        );
        page.classList.add('al-motion-ready');
        groups.forEach((group) => {
          group.classList.add('al-motion-group');
          Array.from(group.children).forEach((child, index) => {
            child.classList.add('al-motion-target');
            child.style.setProperty('--al-motion-order', String(index));
          });
        });

        if ('IntersectionObserver' in window) {
          const revealObserver = new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-revealed');
                entry.target.closest('[data-al-what-chapter]')?.classList.add('is-revealed');
                observer.unobserve(entry.target);
              });
            },
            { rootMargin: '0px 0px -7% 0px', threshold: 0.12 }
          );
          groups.slice(1).forEach((group) => revealObserver.observe(group));
        } else {
          groups.slice(1).forEach((group) => group.classList.add('is-revealed'));
        }
        window.requestAnimationFrame(() => groups[0]?.classList.add('is-revealed'));
      }

      update();
      page.dataset.initialised = 'true';
    };

    const initialiseAll = (root = document) => {
      root.querySelectorAll?.('[data-al-what]').forEach((page) => initialiseWhat(page));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll());
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
